import * as React from 'react';

export default function RenderWindow() {
  return (
    <div className="RenderWindow">
      <img
        id="background-image"
        width="100%"
        height="100%"
        alt="Render window"
      />
    </div>
  );
}
